import React from 'react';
import ChatixCore from 'chatix-core';

class ChatixSDK extends React.Component {
    constructor(props){
        super(props);
        const websiteId = "96489743-c36e-4f36-bb56-8efc420fb62a";
        this.chatroomId = "f1e6e26e-d305-450d-acca-dbf8ccc85071";
        this.sdk = new ChatixCore(websiteId);
        this.sdk.start()
            .then( async () => {
                try {
                    // refresh information about chatroom and call passed handler
                    const chatroom = await this.sdk.getChatroom(this.chatroomId);
                    if (props.updateChatroomTitle) {
                        props.updateChatroomTitle(chatroom.title);
                    }
                    const myChatrooms = await this.sdk.getMyChatrooms();
                    if (myChatrooms.filter(x => x.id===this.chatroomId).length === 0) {
                        await this.sdk.connectToChatroom(this.chatroomId);
                    }

                    // lets get all chatroom members using infinite loop with break on empty server response
                    let membersPage = 1;
                    let allChatroomMembers = [];
                    while(true) {
                        let pagedMembers = await this.sdk.getChatroomMembers(this.chatroomId, membersPage++, 10);
                        allChatroomMembers = [...allChatroomMembers, ...pagedMembers];
                        if (pagedMembers.length === 0) {
                            break;
                        }
                    }
                    if (props.setChatroomMembers) {
                        props.setChatroomMembers(allChatroomMembers);
                    }

                    // lets load 100 last messages from current chatroom
                    const lastMessages = await this.sdk.getChatroomMessages(this.chatroomId, null, 100);
                    if (props.setChatroomMessages) {
                        props.setChatroomMessages(lastMessages);
                    }

                    if (props.setMe) {
                        const me = this.sdk.getVisitor();
                        this.props.setMe(me);
                    }
                } catch (err) {
                    console.error(err);
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }
    render(){
        return null;
    }
}

export default ChatixSDK;